import { useParams } from 'react-router-dom';
import {ServiceData} from '../Items/ServicesItems'
import ScrollToTop from '../ScrollToTop/ScrollToTop';
import withLayout from '../../component/withLayout/withLayout';
import { ServiceContactForm } from "./ServiceContactForm";

const ServicesDetails = () => {
    ScrollToTop();
    const { ServiceName } = useParams();
    const serviceDetail = ServiceData.find(
        (item) => `Application-${item.slug}` === ServiceName
    );
    return (
      <div className="Services-details pt-4 pt-lg-5">
        <div className="container py-5">
          {serviceDetail ? (
        
            <div className="row align-items-center">
                <div className="col-12 col-lg-6 mb-4">
                    <div className="row align-items-center">
                        <div className="col-12 mb-4">
                            <h1 className="text-dark mb-3">{serviceDetail.title}</h1>
                            <div className="image-container mb-4">
                                <img src={serviceDetail.image} alt={serviceDetail.name} className="m-auto d-block img-fluid w-100 h-100" height="100%" width="100%" loading="lazy"/>         
                            </div>
                        </div>
                        <div className="col-12 ">
                            <p className="text-dark">{serviceDetail.description}</p>
                            <p className="text-dark">{serviceDetail.description2}</p>
                            <p className="text-dark">Author: EgeneusCo</p>
                            <p className="text-dark">Tags: {serviceDetail.tags}</p>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-lg-6">
                    <ServiceContactForm serviceDetail={serviceDetail}/>
                </div>
            </div>

          ) : (
            <p className="text-center text-dark">Details Not Found</p>
          )}
        </div>
      </div>
    );
}

export default withLayout(ServicesDetails)